const getRelevantSession = () => localStorage.getItem('session');

export default getRelevantSession;
